import { useEffect, useRef, useState } from "react";
import ImportarRazaoService from "../../../services/ImportarRazaoService";

const corStatus = (tipo?: string) => {
  switch ((tipo || "").toLowerCase()) {
    case "danger": return "text-danger";
    case "warning": return "text-warning";
    case "success": return "text-success fw-bold";
    default: return "text-muted";
  }
};

interface Props {
  uploadId: number;
  empresaNome?: string;
  onClose: () => void;
}

/** Log de progresso de um processamento em andamento (DEVN3-540) — era o passo 3 do wizard. */
const ModalProcessamento = ({ uploadId, empresaNome, onClose }: Props) => {
  const [mensagens, setMensagens] = useState<{ mensagem: string; tipo?: string; data: string }[]>([]);
  const [erro, setErro] = useState(false);
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    let ativo = true;
    const tick = async () => {
      try {
        const s = await ImportarRazaoService.status(uploadId);
        if (!ativo) return;
        setMensagens(s.mensagens);
        setErro(s.erro);
        if (s.erro || s.processou) {
          if (pollRef.current) clearInterval(pollRef.current);
        }
      } catch {
        /* mantém o polling */
      }
    };
    tick();
    pollRef.current = setInterval(tick, 2500);
    return () => {
      ativo = false;
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [uploadId]);

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.4)", zIndex: 9999,
        display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(4px)",
      }}
      onClick={onClose}
    >
      <div
        className="card shadow-lg"
        style={{ width: 640, maxWidth: "92vw", borderRadius: 16, border: "none" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-header d-flex justify-content-between align-items-center py-4 px-5" style={{ background: "#F8FAFC", borderRadius: "16px 16px 0 0" }}>
          <div>
            <h3 className="card-title fw-bolder text-dark m-0" style={{ fontSize: 18 }}>
              {erro ? "A importação falhou" : "Processando a importação..."}
            </h3>
            {empresaNome && <div className="text-muted fs-7">{empresaNome}</div>}
          </div>
          <button className="btn btn-icon btn-sm btn-active-light-primary" onClick={onClose}>
            <i className="bi bi-x fs-2" />
          </button>
        </div>

        <div className="card-body p-5">
          <div className="border rounded p-4 bg-light" style={{ maxHeight: 360, overflowY: "auto" }}>
            {mensagens.length === 0 && <span className="text-muted">Aguardando o worker...</span>}
            {mensagens.map((m, i) => (
              <div key={i} className={corStatus(m.tipo)}>
                <small className="text-muted me-2">{new Date(m.data).toLocaleTimeString("pt-BR")}</small>
                {m.mensagem}
              </div>
            ))}
          </div>
        </div>

        <div className="card-footer d-flex justify-content-end py-4 px-5 bg-light-soft" style={{ borderRadius: "0 0 16px 16px" }}>
          <button className="btn btn-sm btn-secondary px-4" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalProcessamento;
